import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	colorPickerNonFinal: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.option.color-picker-non-final',
		defaultMessage: 'Color Picker',
		description: 'Button to select color for option in Dropdown field',
	},
});
